import { Injectable } from "@angular/core";
import {
  ActivatedRoute,
  CanDeactivate,
  NavigationStart,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";
import { AppConstants } from "../constants/constants";
import { Modes } from "../constants/modes";

export interface ICanDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: "root",
})
export class ComponentExitGuard implements CanDeactivate<ICanDeactivate> {
  isComplete: boolean;
  scormMode;
  isPopStateTriggeredOnce: boolean = false;
  message: string = $localize`:@@confirm-message-alert:You have not finished but you can carry on later.\nAre you sure you wish to leave now?\nSelect OK to leave, or Cancel to carry on now.`;

  constructor(private router: Router, private route: ActivatedRoute) {}

  canDeactivate(component: ICanDeactivate): boolean {
    if (component) {
      this.triggerPopstate();
      if (this.scormMode == Modes.Tracked || this.scormMode == Modes.Screener || this.scormMode == Modes.SkillCheck) {
        if (!this.isComplete) {
          return confirm(this.message);
        }
      }
    }
    return true;
  }

  triggerPopstate() {
    this.route.queryParamMap.subscribe((params) => {
      this.scormMode = params.get(AppConstants.SCORM_MODE);
    });
    if (this.scormMode == Modes.Tracked || this.scormMode == Modes.Screener || this.scormMode == Modes.SkillCheck) {
      this.router.events
        .pipe(filter((event) => event instanceof NavigationStart))
        .subscribe((event: NavigationStart) => {
          if (event.navigationTrigger == AppConstants.POPSTATE) {
            if (this.isPopStateTriggeredOnce == false) {
              history.pushState(null, null, location.href);
              this.isPopStateTriggeredOnce = true;
            }
          }
        });
    }
  }
}
